import React from 'react';
import './RequestCallBack.scss';
import Facebook from '../../../../assets/smartxonnect/facebook.svg';
import Instagram from '../../../../assets/smartxonnect/instagram.svg';
import Youtube from '../../../../assets/smartxonnect/youtube.svg';
import TvsSuccess from '../../../../assets/smartxonnect/tvs-success.svg';
const EnquirySuccessPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="success-popup-overlay">
      <div className="success-popup iqubesu">
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        <div className="success-section iqubesec text-center">
          <i className="icon-tvs-success">
            <img src={TvsSuccess} alt="TvsSuccess" />
          </i>
          <label>Your enquiry is created,you shall receive a call from usin 24 hours.</label>
        </div>

        <div className="footer-section iqubefollow">
          <span>For more updates, follow us on</span>

          <div className="social-links">
            <a
              href="https://www.instagram.com/tvsorbiter/?utm_source=ig_web_button_share_sheet"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon-instagram-fill">
                <img src={Instagram} alt="instagram" />
              </i>
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61558580142483"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon-facebook-fill">
                <img src={Facebook} alt="Facebook" />
              </i>
            </a>

            <a href="https://www.youtube.com/@TVSOrbiter" target="_blank" rel="noopener noreferrer">
              <i className="icon-youTube">
                <img src={Youtube} alt="Youtube" />
              </i>
            </a>
          </div>
        </div>

        {/* <button className="btn primary-gradient-btn" onClick={onClose}>
          Close
        </button> */}
      </div>
    </div>
  );
};

export default EnquirySuccessPopup;
